/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Credit charge record for billing
 * @export
 * @interface CreditCharge
 */
export interface CreditCharge {
    /**
     * 
     * @type {number}
     * @memberof CreditCharge
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof CreditCharge
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof CreditCharge
     */
    creditUsageId: number;
    /**
     * 
     * @type {number}
     * @memberof CreditCharge
     */
    amountCents: number;
    /**
     * 
     * @type {number}
     * @memberof CreditCharge
     */
    creditsCharged: number;
    /**
     * 
     * @type {string}
     * @memberof CreditCharge
     */
    status: CreditChargeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreditCharge
     */
    failureReason?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreditCharge
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreditCharge
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreditCharge
     */
    chargedAt?: Date | null;
}


/**
 * @export
 */
export const CreditChargeStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Succeeded: 'succeeded',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;
export type CreditChargeStatusEnum = typeof CreditChargeStatusEnum[keyof typeof CreditChargeStatusEnum];


/**
 * Check if a given object implements the CreditCharge interface.
 */
export function instanceOfCreditCharge(value: object): value is CreditCharge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('creditUsageId' in value) || value['creditUsageId'] === undefined) return false;
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('creditsCharged' in value) || value['creditsCharged'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CreditChargeFromJSON(json: any): CreditCharge {
    return CreditChargeFromJSONTyped(json, false);
}

export function CreditChargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCharge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'creditUsageId': json['creditUsageId'],
        'amountCents': json['amountCents'],
        'creditsCharged': json['creditsCharged'],
        'status': json['status'],
        'failureReason': json['failureReason'] == null ? undefined : json['failureReason'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'chargedAt': json['chargedAt'] == null ? undefined : (new Date(json['chargedAt'])),
    };
}

export function CreditChargeToJSON(json: any): CreditCharge {
    return CreditChargeToJSONTyped(json, false);
}

export function CreditChargeToJSONTyped(value?: Omit<CreditCharge, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'creditUsageId': value['creditUsageId'],
        'amountCents': value['amountCents'],
        'creditsCharged': value['creditsCharged'],
        'status': value['status'],
        'failureReason': value['failureReason'],
        'chargedAt': value['chargedAt'] == null ? undefined : ((value['chargedAt'] as any).toISOString()),
    };
}

